module.exports = __webpack_public_path__ + "img/comment_award.e1786b64.png";